<template>
  <div>
    <div>
      <page-header
        :title="formData ? formData.id ? 'Editting user' : 'Adding user' : 'Site users'"
        :commands="[{
          click: formData ? handleCancelEditUserClick : handleAddUserClick,
          icon: formData ? 'x' : '+',
          text: formData ? formData.id ? 'Cancel edit user' : 'Cancel new user' : 'Add new user'
        }]"
      />
      <!-- EDITTING / ADDING USER -->
      <form-renderer
        v-if="formData"
        :fieldData="getFormData()"
        :onSubmit="handleSubmitButtonClick"
        :order="['User Data', 'Contact']"
        :styler="{ groupHeaderColor: `#${colors.maroon}` }"
      />
      <div class='container'>
        <p class='center pb-5 pt-10 info-badge' v-if='!formData'>
          <span>
            {{ userList.length }} total users
          </span>
        </p>
        <div class='site-users-list l-reset' v-if='!formData'>
          <my-icon-card
            v-for="(user, index) in userList"
            :key="index"
            :icon="user.userType && user.userType.charAt(0).toUpperCase()"
            :data="user"
            :displayKeys="dataItemKeys"
            :color="'#1FDD00'"
            :rows="4"
            :altRows="{'signOff': 100, 'disclaimer': 100}"
            :menu="{
              edit: {
                action: user => handleEditUserClick(user.id),
                icon: 'pencil-alt',
                color: '#7CFF67'
              }
            }"
          />
        </div> 
      </div>
    </div>
  </div>
</template>

<script>
import MyIconCard from '@/myComponents/MyIconCard.vue'
import FormRenderer from '../../components/FormRenderer.vue';
import colors from '../../constants/colors.js';
import { localParse } from '../../utils/date';
import PageHeader from '../../components/PageHeader.vue';
export default {
  name: "ManageSiteUsers",
  components: { MyIconCard, FormRenderer, PageHeader },
  data: function () {
    return {
      colors,
      formData: null,
      large: ['disclaimer', 'signOff'],
      staticFields: ['id', 'resourceid'],
      dataItemKeys: ['id', 'username', 'email', 'companyName', 'number', 'site', 'address', 'lastSync', 'userType', 'resourceid', 'signOff', 'disclaimer']
    };
  },
  mounted: function () {
    this.$store.dispatch("loadSataStoreData", {
      key: "userList",
      url: "/admin/userdata/get-all-users/",
    });
  },
  computed: {
    dataStore: function () {
      return this.$store.getters.dataStore;
    },
    userList: function () {
      return this.dataStore && this.dataStore.userList ? [...this.dataStore.userList]
        .map(user => ({
          ...user,
          username: user.username.substring(3),
          lastSync: user.lastSync ? localParse(user.lastSync) : ''
        })) : [];
    },
  },
  methods: {
    getFormData: function () { 
      const makeField = FormRenderer.methods.makeFieldItem
      const disabled = ['id', 'resourceid', 'lastSync']
      const para = ['disclaimer', 'signOff']
      const long = ['disclaimer', 'signOff', 'address', 'resourceid']
      const groups = {
        'User Data': ['username', 'site', 'companyName', 'userType'],
        'Contact': ['email', 'number', 'address'],
        'Invoice': ['disclaimer', 'signOff'],
      }
      const fields = Object.keys(this.formData).map(key => {
        return makeField(
          key,
          key.charAt(0).toUpperCase() + key.split('').splice(1, key.length).join(''),
          Object.keys(groups).reduce((prev, curr) => {
            if (prev !== 'General') return prev
            if (groups[curr].includes(key)) {
              return curr
            } else return 'General'
          }, 'General'),
          long.includes(key) ? 'long' : '',
          this.formData[key],
          para.includes(key) ? 'textarea' : 'text',
          disabled.includes(key)
        )
      })
      return fields
    },
    handleAddUserClick: function () {
      this.formData = this.dataItemKeys.reduce((prev, curr) => {
        if (curr === 'id') return prev
        return {
          ...prev,
          [curr]: ''
        }
      }, {})
    },
    handleCancelEditUserClick: function () {
      this.formData = null
    },
    handleEditUserClick: function (id) {
      const user = [...this.userList].filter(u => u.id === id)
      if (user && user.length > 0) {
        let formData = {
          ...user[0]
        }
        this.formData = formData
      }
    },
    handleSubmitButtonClick: function (formData) {
      console.log(formData)
      console.log(this.formData)
    },
    handleUpdateField: function (e) {
      this.formData = {
        ...this.formData,
        [e.target.name]: e.target.value
      }
    }
  },
};
</script>

<style lang="scss">
@import "../../styles/colors.scss";
@import "../../styles/vars.scss";
.info-badge {
  margin: 10px auto;
  span {
    padding: 3px 7px;
    color: #fff;
    border-radius: 6px;
    background-color: $lightBlue;
  }
}
.site-users-list {
  $sideWidth: 80px;
  $sideWidthClosed: 30px;
  li {
    background-color: #fff;
    width: 100%;
    color: rgb(88, 88, 88);
    border-radius: 5px;
    margin-bottom: 13px;
    &:hover {
      cursor: pointer;
    }
    & > div {
      width: $sideWidth;
      background-color: $green;
      border-radius: 5px 0 0 5px;
      color: #fff;
      font-weight: bold;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      text-shadow: 0 0 6px rgba(0, 0, 0, .3);
      span {
        font-size: 2rem;
        opacity: .5;
      }
    }
    & > span {
      display: flex;
      padding: 10px;
      width: calc(100% - #{$sideWidth});
      margin: 0 auto;
      justify-content: space-between;
      flex-wrap: wrap;
      span {
        width: calc(100% / 4);
        padding-bottom: 10px;
        &.large {
          width: calc(100% - 16px);
          background-color: #f9f9f9;
          border-radius: 5px;
          padding: 8px;
          margin-top: 4px;
          margin-bottom: 6px;
        }
        & label {
          font-weight: bold;
          width: 100%;
          display: block;
        }
      }
    }
  }
}
.user-data-form {
  padding-bottom: 16px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  background-color: #fff;
  width: 96%;
  margin: 10px auto 50px auto;
  .form-error {
    color: red;
    font-weight: bold;
  }
  h4 {
    width: 96%;
    font-size: 1.3rem;
    color: $maroon;
    margin: 31px 0 5px 0;
  }

  & > span.between {
    width: 96%;
    display: flex;
    justify-content: space-between;
    button {
      width: 185px;
      margin-top: 20px;
      padding-right: 12px;
    }
    h4 {
      width: auto;
    }
  }
  & > div {
    width: 48%;
    label {
      display: block;
      width: 100%;
      font-weight: bold;
      margin-bottom: 13px;
      margin-top: 20px;
      color: rgb(161, 161, 161);
    }
    .check-box {
      margin-top: 15px;
      width: 100%;
      display: flex;
      align-content: center;
      label {
        cursor: pointer;
        width: auto;
      }
      input[type="checkbox"] {
        cursor: pointer;
        display: block;
        margin: 22px 10px 0 0;
      }
    }
    input[type="text"],
    input[type="number"],
    input[type="date"],
    select,
    textarea {
      box-shadow: 0 0 0 1px rgb(117, 197, 228);
      padding: 13px 10px;
      border-radius: 4px;
      background-color: rgb(240, 251, 255);
      width: calc(96% - 20px);
      transition: all 0.5s;
      &:focus {
        background-color: rgb(217, 243, 252);
        box-shadow: 0 0 0 1px rgb(41, 155, 201);
      }
      
      &:disabled {
        background-color: rgb(235, 235, 235);
        box-shadow: 0 0 0 1px rgb(192, 192, 192);
        color: gray;
      }
    }
    input[type="date"] {
      padding: 10px 10px;
    }
    select {
      margin: 0;
      width: calc(100% - 20px);
      padding: 12px 0 11px 10px;
    }
    textarea {
      height: 90px;
      line-height: 1.75rem;
    }
  }
  & .long {
    width: 96%;
    input[type="text"],
    textarea {
      border-radius: 4px;
      width: calc(98% - 20px);
    }
  }
  .balance {
    font-size: 2rem;
    color: $green;
    font-weight: bold;
    margin: 16px 0 0 0;
  }
  @media screen and (max-width: 460px) {
    & > div {
      width: 96%;
    }
  }
  .hasError {
    & input[type="text"],
    & input[type="number"],
    & input[type="date"],
    & select,
    & textarea {
      box-shadow: 0 0 0 1px rgb(228, 117, 117);
      background-color: rgb(255, 240, 247);
    }
    label {
      color: red;
    }
  }
}

.field-error {
  font-style: italic;
  padding: 2px 8px;
  display: inline-block;
  color: red;
  margin-top: 8px;
  border-radius: 5px;
  margin-left: 5px;
  color: #fff;
  background-color: red;
}
</style>
